<template>
    <div class="kv-filter-container">

        <div class="kv-filter-label">{{ label }}</div>

        <KvPopup max-width="400px" ref="popup">
            <template #trigger="{ toggle }">
                <span class="kv-filter-input" :title="valueLabel" @click="toggle">
                    <Icon icon-class="ui-chevron-down" />
                    {{ valueLabel }}
                    <span class="kv-remove-filter" v-if="removable" @click.stop="$emit('remove')">
                        <Icon icon-class="ui-x-close" size="2" color="#212529" />
                    </span>
                </span>
            </template>

            <template #content="{ toggle }">
                <div class="kv-checkbox-options mt-3">

                    <KvScrollbar content-class="kv-options">
                        <span class="kv-checkbox" v-for="(option, index) in branches" :key="index" @click="toggleBranch(option.id)">
                            <KvCheckbox :id="`filter-${option.id}-${index}`" :checked="isChecked(option.id)" :label="option.title" />
                        </span>
                    </KvScrollbar>

                    <div class="kv-popup-actions">
                        <KvButton full-width variant="outlined" @click="cancel(toggle())">
                            {{ t('reportFilters-cancel') }}
                        </KvButton>
                        <KvButton full-width prepend-icon="ui-check" variant="filled" @click="apply(toggle())">
                            {{ t('reportFilters-apply') }}
                        </KvButton>
                    </div>
                </div>
            </template>
        </KvPopup>
    </div>
</template>
<script>
import KvInput from '../../inputs/kv-input.vue';
import KvPopup from '../../ui/kv-popup.vue';
import KvCheckbox from '../../inputs/kv-checkbox.vue';
import KvScrollbar from '@/components/ui/kv-scrollbar.vue';

export default {
    name: "kv-branch-filter",
    components: {
        KvPopup,
        KvInput,
        KvCheckbox,
        KvScrollbar
    },
    props: {
        name: {
            type: String,
            default: "kv-branch-filter",
        },
        currentValue: {
            type: [Array, String, Number],
            default: null,
        },
        removable: Boolean,
        label: String,
    },
    data() {
        return {
            value: [],
            newValue: [],
            focus: false,
        };
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
            this.newValue = [...this.value];
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        toggleBranch(id) {
            let idx = this.newValue.indexOf(id);
            if (idx === -1) {
                this.newValue.push(id);
            } else {
                this.newValue.splice(idx, 1);
            }
        },
        isChecked(id) {
            return this.newValue.indexOf(id) !== -1;
        },
        apply() {
            this.value = [...this.newValue];
        },
        cancel() {
            this.newValue = [...this.value];
        },
        changed() {
            this.$emit("changed", this.value.length > 0 ? this.value : null);
        },
    },
    computed: {
        valueLabel() {
            if (this.value.length === 0) {
                return this.t('reportFilters-select');
            }
            let label = this.value.map((id) => this.branchesMap[id]).join(", ");
            if (label.length > 30) {
                label = label.substr(0, 27) + "...";
            }
            return label;
        },
        branchesMap() {
            let branchesMap = {};
            for (let b in this.branches) {
                let branch = this.branches[b];
                branchesMap[branch.id] = branch.title;
            }
            return branchesMap;
        },
        branches() {
            return this.$store.state.place.branches.filter((b) =>
                parseInt(b.active),
            );
        },
    },
    watch: {
        focus(newValue) {
            this.$refs.popup.toggleShow(newValue);
        },
        value() {
            this.changed();
        },
    },
};
</script>
